import { createSvgIcon } from '@material-ui/core/utils';

export const MyDataProductIcon = createSvgIcon(
  <>
    <path d="m17.09 12-2.55 4.4H9.46L6.91 12l2.55-4.41h5.08L17.09 12z" />
    <path d="M17.38 2.67H6.62L1.23 12l5.39 9.32h10.76L22.77 12l-5.39-9.33Zm-10 17.32L2.77 12l4.61-8h9.24l4.61 8-4.61 7.99H7.38Z" />
    <path d="m17.09 12-2.55 4.4H9.46L6.91 12l2.55-4.41h5.08L17.09 12z" />
  </>,
  'MyDataProductIcon',
);
